/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    exports.showAlertBox = function (type, message, buttons, callback) {
        if(window.cxp && window.cxp.mobile) {
            var plugin = cxp.mobile.plugins['AlertDialog'];
            if (plugin) {
                plugin.show(function(data){
                    callback(data);
                }, null, type, message, JSON.stringify(buttons));
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/mobile-dialog.js
// module id = 42
// module chunks = 0